<mat-card class="edit-info-menu mat-elevation-z8">
    <mat-card-subtitle >
        <span>
            <span class="document-name">{{documentName}}</span> <span id="document-status">{{documentStatus}}</span>
        </span>

        <br>
        <div *ngFor='let item of cntData | keyvalue' class="attribute-values">
            <span>{{item.key}}</span> &nbsp;:
            <ng-container *ngIf="isObject(item.key); else elseTemplate">
                <div *ngFor="let j of item.value | keyvalue">
                    &nbsp;<span>{{j.key}}</span>  &nbsp;:&nbsp; <span>{{j.value}}</span>
                </div>
            </ng-container>
            <ng-template #elseTemplate>
                &nbsp; <span>{{item.value}}</span>
            </ng-template>
        </div>

    </mat-card-subtitle>

    <mat-card-content >
  
        <mat-expansion-panel *ngFor="let link of valueConfPageDtos; let i = index" (click)="expand(link)" hideToggle>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    {{link.name}}
                </mat-panel-title>
            </mat-expansion-panel-header>           
            <generic-form  [pagedId]="link.id" [attr.data-page-id]="link.id" [attr.data-index]="i" (docStatus)="docStatusHandler($event)" ></generic-form>
        </mat-expansion-panel>
   
        <!-- <router-outlet></router-outlet> -->

    </mat-card-content>
</mat-card>